import { useState, useEffect } from "react";

function useStores(stores) {
  if (!Array.isArray(stores) || stores.length === 0) {
    console.error('useStores without stores as argument');
  }

  const [, setState] = useState({});

  function onChange() {
    setState({});
  }

  useEffect(() => {
    stores.forEach((store) => store.addChangeListener(onChange));

    return (() => {
      stores.forEach((store) => store.removeChangeListener(onChange));
    });
  }, [stores]);
}

export default useStores;
